import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import { Pop } from 'kts-platform-frame/redux/reducers/rightPopUps/Node';
import ReduxState, { IRightPopUps } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIContainer from './UI.Container';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    rightPopUps?: IRightPopUps;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 右侧弹出窗口 */
@connect((state: ReduxState): IReduxStatePart => ({
    rightPopUps: state.rightPopUps,
}))
export default class RightPopUps extends ModulesBasic<IProps, ModulesState> {

    public readonly state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { popList } = this.props.rightPopUps;
        return (
            <ModulesRoot action={ModulesAction}>
                {
                    popList.map((item: Pop, index: number) => (
                        <UIContainer key={index} title={item.title} width={item.width} isHide={item.isHide} >
                            {item.Components}
                        </UIContainer>
                    ))
                }
            </ModulesRoot>
        );
    }
}




// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/RightPopUps/index.tsx